/* B03-only Fabrics & Materials navigation. Shopify's shared menus are not modified. */
(()=>{'use strict';
const url='/pages/contact?view=fabrics-and-materials';
const configs=[
 {selector:'bbc-site-header .bbc-header__nav-list',item:'bbc-header__nav-item',link:'bbc-header__nav-link'},
 {selector:'bbc-site-header .bbc-drawer__list',item:'bbc-drawer__item',link:'bbc-drawer__link'}
];
function install(list,config){
 if(!list)return;
 const entries=Array.from(list.children);
 const pro=entries.find(item=>{const control=item.querySelector(':scope > a,:scope > button');return control&&/professionals/i.test(control.textContent||'');});
 if(!pro)return;
 let item=entries.find(node=>node.matches('[data-bbc-materials-nav]'));
 if(!item){
   item=document.createElement('li');item.className=config.item;item.setAttribute('data-bbc-materials-nav','');
   const link=document.createElement('a');link.className=config.link;link.href=url;link.textContent='Fabrics & Materials';link.setAttribute('aria-label','Our Fabrics and Materials');
   item.appendChild(link);
 }
 if(pro.nextElementSibling!==item)pro.insertAdjacentElement('afterend',item);
 const link=item.querySelector('a');
 if(link){const current=new URLSearchParams(location.search).get('view')==='fabrics-and-materials';link.classList.toggle('is-active',current);if(current)link.setAttribute('aria-current','page');else link.removeAttribute('aria-current');}
}
function run(){configs.forEach(config=>document.querySelectorAll(config.selector).forEach(list=>install(list,config)));}
function start(){run();const header=document.querySelector('bbc-site-header');let pending=false;const queue=()=>{if(pending)return;pending=true;requestAnimationFrame(()=>{pending=false;run();});};if(header)new MutationObserver(queue).observe(header,{childList:true,subtree:true});document.addEventListener('shopify:section:load',queue);window.addEventListener('pageshow',queue);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
